var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeRebrandCardVision(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 3H21V7",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.575 11.082C19.9989 13.8669 20.371 17.0719 19.623 20.109C19.5752 20.305 19.4774 20.4853 19.3393 20.6324C19.2012 20.7795 19.0274 20.8884 18.8347 20.9485C18.6421 21.0086 18.4372 21.0178 18.24 20.9753C18.0427 20.9329 17.8598 20.8401 17.709 20.706L14 17",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7 10L3.29 6.29C3.15692 6.13896 3.06506 5.95614 3.02331 5.75922C2.98155 5.5623 2.99131 5.35793 3.05164 5.16588C3.11197 4.97383 3.22083 4.8006 3.36769 4.66293C3.51456 4.52526 3.69446 4.42781 3.89 4.38C6.92828 3.63186 10.1345 4.00467 12.92 5.43",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7 14C6.77578 13.9996 6.5537 14.0436 6.34655 14.1294C6.1394 14.2152 5.95127 14.3412 5.793 14.5L3.147 17.146C3.07695 17.2159 3.02921 17.3049 3.00981 17.402C2.99041 17.499 3.00023 17.5996 3.03803 17.691C3.07582 17.7824 3.13989 17.8606 3.22212 17.9156C3.30436 17.9706 3.40106 18 3.5 18H5C5.26522 18 5.51957 18.1054 5.70711 18.2929C5.89464 18.4804 6 18.7348 6 19V20.5C5.99982 20.599 6.02905 20.6959 6.08398 20.7783C6.13891 20.8606 6.21706 20.9249 6.30854 20.9628C6.40001 21.0007 6.50068 21.0106 6.59779 20.9912C6.6949 20.9719 6.78407 20.9241 6.854 20.854L9.5 18.207C9.65882 18.0487 9.78476 17.8606 9.87058 17.6535C9.95639 17.4463 10.0004 17.2242 10 17V15C10 14.7348 9.89464 14.4804 9.70711 14.2929C9.51957 14.1054 9.26522 14 9 14H7Z",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.707 14.293L21 3",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeRebrandCardVision);
export default __webpack_public_path__ + "static/media/home-rebrand-card-vision.21cfbf7d35f1725189693c42c6e1bdb4.svg";
export { ForwardRef as ReactComponent };